import { render, staticRenderFns } from "./PesquisarFerias.vue?vue&type=template&id=753144c2"
import script from "./PesquisarFerias.vue?vue&type=script&lang=js"
export * from "./PesquisarFerias.vue?vue&type=script&lang=js"
import style0 from "./PesquisarFerias.vue?vue&type=style&index=0&id=753144c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports